import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-cream-dark/60 py-8 text-center text-sm" data-id="element-27">
      <div className="max-w-4xl mx-auto px-4" data-id="element-28">
        <p className="mb-4 font-serif text-gold-muted text-lg" data-id="element-29">Cadenas Rotas</p>
        <p data-id="element-30">&copy; {new Date().getFullYear()} Todos los derechos reservados.</p>
        <p className="mt-2 text-xs max-w-2xl mx-auto opacity-50" data-id="element-31">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}